import { render, staticRenderFns } from "./EquipmentForm.vue?vue&type=template&id=653b5a5a&scoped=true&lang=pug"
import script from "./EquipmentForm.vue?vue&type=script&lang=js"
export * from "./EquipmentForm.vue?vue&type=script&lang=js"
import style0 from "./EquipmentForm.vue?vue&type=style&index=0&id=653b5a5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b5a5a",
  null
  
)

export default component.exports